import { AppBar, Toolbar } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { LuBell as NotificationsIcon, LuMenu as MenuIcon } from 'react-icons/lu';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import clientConfig from '../../../../config/client-config';
import { AppState } from '../../../../infra/store';
import Websocket from '../../../components/websocket';

export type MobileHeaderProps = {
  onMenuClick: () => void;
  onNotificationsClick: () => void;
};

const MobileHeader = ({ onMenuClick, onNotificationsClick }: MobileHeaderProps) => {
  const navigate = useNavigate();
  const logo = useSelector((state: AppState) => state.themeReducer.logo);

  return (
    <AppBar elevation={0} color="default" style={{ maxHeight: 64, minHeight: 64, background: 'var(--bg-color)' }}>
      <Toolbar>
        <IconButton edge="start" color="inherit" aria-label="menu" onClick={onMenuClick}>
          <MenuIcon />
        </IconButton>
        <Websocket />
        <img
          height={30}
          src={logo}
          alt={clientConfig.branding.logoAltText}
          onClick={() => navigate('/')}
          style={{ flexGrow: 1, cursor: 'pointer' }}
        />
        <IconButton edge="end" color="primary" aria-label="notifications" onClick={onNotificationsClick}>
          <NotificationsIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default MobileHeader;
